import { render, staticRenderFns } from "./BackInStockNotification.vue?vue&type=template&id=05aa01ba&"
import script from "./BackInStockNotification.vue?vue&type=script&lang=js&"
export * from "./BackInStockNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports